import React from 'react';
import { RadioGroup } from '../elements-inputs/radio-group';
import { ReviewStars } from 'shared-components/inputs/stars';
import { ListingImage } from '../elements-image/listing-image';
import { Avatar } from 'shared-components/image/avatar';
import { FormBuilder } from 'shared-components/forms/form';
import Reviews from '../../../api/api-reviews';
import { get } from 'lodash';
import { FormattedMessage, FormattedDate, injectIntl } from 'react-intl';

/*
Dependent Props:
- review
- user
- updateAction
- callback
*/

class ReviewForm extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      msgError: null,
      is_host: false,
      is_guest: false,
      review: null,
      reviewFor: null,
      starValCaptured: null,
      bookAgainCaptured: null,
      reviewTextCaptured: null
    };

    this.getReviewee = this.getReviewee.bind(this);
    this.captureStarRating = this.captureStarRating.bind(this);
    this.captureBookAgain = this.captureBookAgain.bind(this);
    this.captureReviewText = this.captureReviewText.bind(this);
    this.submitReview = this.submitReview.bind(this);
    this.submitReviewCb = this.submitReviewCb.bind(this);
    this.bookingAgainToggle = this.bookingAgainToggle.bind(this);
    this.renderReviewForm = this.renderReviewForm.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);
    this.validateInput = this.validateInput.bind(this);
  }

  getAccessToken () {
    let accessToken;
    if (this.props.params && this.props.params.accessToken) {
      accessToken = this.props.params.accessToken;
    } else if (document && document.cookie) {
      accessToken = PSSessions.Cookies.get('PSAccess');
    } else {
      accessToken = null;
    }
    return accessToken;
  }

  getReviewee () {
    const {
      review_type,
      guest,
      listing,
      booking,
      use_type
    } = this.props.review;

    const image = {
      ratio: 1.689,
      widths: [200],
      defaultWidth: 400,
      defaultHeight: 236,
      alt: 'Peerspace',
      imgId: listing.images[0].external_id,
      style: 'img-responsive listing-image'
    };
    if ('guest' === review_type) {
      return (
        <div className="guest-review">
          <Avatar id={guest.avatar_id} />
          <h5 className="text-left ellipsis">{guest.name.first || ''} {guest.name.last || ''}</h5>
          <h5 className="text-left ellipsis">{listing.title}</h5>
          <div className="text-gray-dark text-left">{use_type}</div>
          <div className="text-gray-dark text-left">
            <FormattedDate
              value={booking.start.display.date}
              year="numeric"
              month="short"
              day="numeric"
              weekday="short"
            />
          </div>
        </div>
      );
    }
    return (
      <div>
        <ListingImage
          {...image}
        />
        <h5 className="text-left ellipsis">{listing.title}</h5>
        <p className="text-gray-dark text-left">
          <FormattedDate
            value={booking.start.display.date}
            year="numeric"
            month="short"
            day="numeric"
            weekday="short"
          />
        </p>
      </div>
    );
  }

  captureStarRating (starVal) {
    this.setState({ starValCaptured: parseInt(starVal, 10) });
  }

  captureBookAgain (selectedElement) {
    this.setState({ bookAgainCaptured: 'accepted' === selectedElement.value ? 'true' : 'false' });
  }

  captureReviewText (event, cb) {
    this.setState({
      reviewTextCaptured: event['review-message']
    });
    return cb();
  }

  validateInput (errorData, validState) {
    return validState(errorData);
  }

  submitReview (e, cb) {
    const accessToken = this.getAccessToken();
    const data = {
      stars: this.state.starValCaptured,
      review_text: this.state.reviewTextCaptured,
      would_you_book_again: 'true' === this.state.bookAgainCaptured
    };
    const reviewID = this.props.review._id;
    if (accessToken) {
      return Reviews.update(reviewID, accessToken, data, cb);
    }
  }

  submitReviewCb (response) {
    if (response.error || 400 < response.statusCode) {
      // Something went wrong when creating the message
      return this.setState({
        msgError: <FormattedMessage id='inbox.review_form.something_wrong' defaultMessage='Something went wrong. Please try again.' />
      });
    }

    const { review, booking, redirectOnSuccess } = this.props;
    if ('space' === review.review_type && redirectOnSuccess) {
      const { bookAgainCaptured } = this.state;
      const bookAgainValue = 'true' === bookAgainCaptured ? 'yes' : 'no';
      const { use_type, booking_id, booking, reviewer_id } = review;
      const activity = get(booking, 'tags.activity', '');
      const useTypeObj = {
        'Off-Site': 'meetings',
        Production: 'production',
        Event: 'events'
      };

      let urlDomain = 'book.peerspace.com';
      if ('test' === process.env.NODE_ENV || 'development' === process.env.NODE_ENV) {
        urlDomain = 'peerspace.webflow.io';
      }

      return location.href = `https://${urlDomain}/reviews/${useTypeObj[use_type]}?bkg=${booking_id}&book_again=${bookAgainValue}&role=guest&activity=${activity}&sso=${reviewer_id}&review=${review._id}`;
    }

    return this.props.cbAction(review._id);
  }

  bookingAgainToggle () {
    const { review_type } = this.props.review;

    return (
      <div className="col-xs-12 margin-xl-top">
        <RadioGroup
          isRequired
          ref="radio"
          groupName="book-again"
          changeCB={this.captureBookAgain}
          customErrorMessage={this.props.intl.formatMessage({ id: 'inbox.review_form.select_option', defaultMessage: 'Please select an option.' })}
          inputData={[
            {
              ID: 'yes',
              value: 'accepted',
              displayText: 'guest' === review_type
                ? this.props.intl.formatMessage({ id: 'inbox.review_form.host_again', defaultMessage: 'Yes, I would host them again' })
                : this.props.intl.formatMessage({ id: 'inbox.review_form.book_again', defaultMessage: 'Yes, I would book again' })
            },
            {
              ID: 'no',
              value: 'declined',
              displayText: 'guest' === review_type
                ? this.props.intl.formatMessage({ id: 'inbox.review_form.not_host_again', defaultMessage: 'No, I would not host them again' })
                : this.props.intl.formatMessage({ id: 'inbox.review_form.not_book_again', defaultMessage: 'No, I would not book again' })
            }
          ]}
        />
      </div>
    );
  }

  renderReviewForm () {
    const reviewInputMetaData = [
      {
        inputFieldName: 'review_response',
        elementID: 'review-message',
        ref: 'reviewMsg',
        optional: false,
        actionFn: this.captureReviewText,
        actionCb: this.validateInput,
        placeholder: this.props.intl.formatMessage({ id: 'inbox.review_form.leave_review', defaultMessage: 'Leave a review' }),
        errorMessage: <FormattedMessage id='inbox.review_form.review_more_chars' defaultMessage='Your review must be more than five characters long.' />,
        hideRequired: true
      },
      {
        custom: () => (<ReviewStars onChangeFn={this.captureStarRating} ref="review-stars" />)
      },
      {
        custom: this.bookingAgainToggle
      }
    ];

    return (
      <FormBuilder
        ref="reviewForm"
        formStyle="standard"
        formname="review form"
        formInputs={reviewInputMetaData}
        submitAction={this.submitReview}
        submitCallback={this.submitReviewCb}
        isButtonDisabled={false}
        buttonText={ <FormattedMessage id='inbox.review_form.submit_review' defaultMessage='Submit Review' /> }
        buttonClass="btn btn-primary"
        errorText={this.state.msgError}
      />
    );
  }

  render () {
    let revieweeName;
    const revieweeInfo = this.getReviewee();
    const {
      review_type,
      guest,
      host
    } = this.props.review;
    if ('guest' === review_type) {
      revieweeName = guest.name.first || '';
    } else {
      revieweeName = host.name.first || '';
    }

    return (
      <div id="complete-review">
        <div id="review-form-left" className="col-sm-4 text-center">
          {revieweeInfo}
        </div>
        <div id="review-form-right" className="col-sm-8">
          <div className="venue_info">
            <h3>
              { 'guest' === review_type
                ? <FormattedMessage id='inbox.review_form.review_guest' defaultMessage='Review your guest' />
                : <FormattedMessage id='inbox.review_form.review_space' defaultMessage='Review this space' />
              }
            </h3>
            <p>
              <FormattedMessage
                id='inbox.review_form.feedback_help'
                defaultMessage='Your feedback will help other {reviewType} know what to expect. Please describe your experience booking with {name}.'
                values={{
                  reviewType: 'guest' === review_type
                    ? <FormattedMessage id='inbox.review_form.guests' defaultMessage='guests' />
                    : <FormattedMessage id='inbox.review_form.hosts' defaultMessage='hosts' />,
                  name: revieweeName
                }}
              />
            </p>
            <ul>
              <li>
                {'guest' === review_type
                  ? <FormattedMessage id='inbox.review_form.how_easy' defaultMessage='How easy were they to work with?' />
                  : <FormattedMessage id='inbox.review_form.how_responsive' defaultMessage='How responsive was the host?' />
                }
              </li>
              <li>
                {'guest' === review_type
                  ? <FormattedMessage id='inbox.review_form.booking_planned' defaultMessage='Did the booking go as planned?' />
                  : <FormattedMessage id='inbox.review_form.space_advertised' defaultMessage='Did the space appear as advertised?' />
                }
              </li>
              <li>
                {'guest' === review_type
                  ? <FormattedMessage id='inbox.review_form.they_follow_rules' defaultMessage='Did they follow your host rules?' />
                  : <FormattedMessage id='inbox.review_form.what_activity' defaultMessage='What activity did you do in the the space?' />
                }
              </li>
            </ul>
          </div>
          <div id="review-helper-text">
            <p>
              <FormattedMessage
                id='inbox.review_form.your_review'
                defaultMessage='Your review will be kept private until {revieweeName} completes their review.'
                values={{
                  revieweeName
                }}
              />
            </p>
          </div>
          { this.renderReviewForm() }
        </div>
      </div>
    );
  }
}

exports.ReviewForm = injectIntl(ReviewForm);
